import Vue from 'vue';
import Vuex from 'vuex';
import flatpickr from "flatpickr";

import CustomerData from '../used-vue/store/modules/customer-data';
import Dealers from '../used-vue/store/modules/dealers';
import OSB from '../used-vue/store/modules/osb';
import Auth from '../used-vue/store/modules/auth';
import Layout from '../used-vue/store/modules/layout';


Vue.use(Vuex);

var store  = new Vuex.Store({
    modules: {
        CustomerData,
        Dealers,
        OSB,
        Auth, 
        Layout
    },
});

window.axios = require('axios');

Vue.component('online-service-booking', require('./OnlineServiceBooking.vue').default);

const app = new Vue({
    el: '#onlineServiceBooking',
    data: {},
    mixins: [{
        methods: {
            flatpickr
        }
    }],
    store,
    mounted() {
        const loadingArea = document.getElementById('findMyCarLoadingArea');
        if (!loadingArea) {
            return;
        }
        loadingArea.remove();
    }
});